import ValidService from "../../../service/ValidService";
let model = {};

// dữ liệu form
model.dataForm = {
  name: null, // required - Tên loại văn bản
  short_name: null, // optional - Tên viết tắt loại văn bản
  code: null, // optional, maxLength: 50 - Mã loại văn bản
  type: null, // required, enum(DOC_TYPE, DOC_SECRET, DOC_URGENCY) - Loại
  order: null, // optional - Thứ tự
  target_id: null, // required - Id công ty, chi nhánh, ... tùy thuộc vào type
  target_other: null, // optional - Tên mô hình khác
  organization_model_id: null, // required, ref: organization_model - Đơn vị
  year: null, // required
};

model.dataBreadCrumd = [
  {
    name: 'Trang chủ',
    path: '/admin/hello',
  },
  {
    name: 'Văn bản điện tử',
    path: '/admin/DocumentsGeneral?tab=VanBanDen',
  },
  {
    name: '',
    path: '',
  },
]

// validation form
model.validForm = {
  name: [ValidService.required, ValidService.checkLength1(1,255), ValidService.checkSpaceString],
  code: [ValidService.required, ValidService.checkSpaceString, ValidService.checkSpaceStringCenter, ValidService.checkLength1(1,50)],
  short_name: [ValidService.checkSpaceString, ValidService.checkSpaceStringCenter, ValidService.checkLength1(1,50)],
  type: [ValidService.requiredChange],
  order: [ValidService.checkNumberInteger, ValidService.checkNumberFloatNotNegative],
  organization_model_id: [ValidService.requiredChange],
  target_id: [ValidService.requiredChange],
  target_other: [ValidService.required, ValidService.checkLength1(1,255), ValidService.checkSpaceString],
};

model.dataFormOrganizationModel = {
  name: null, // required - Tên loại văn bản
  order: null, // optional - Thứ tự
  parent_id: null, // optional, ref: work_unit - Đơn vị cha
  employee_ids: [], // optional, Danh sách người dùng thuộc mô hình tổ chức
  type: null, // optional, loại
};

// validation form
model.validFormOrganizationModel = {
  name: [ValidService.required, ValidService.checkLength1(1,255), ValidService.checkSpaceString],
  order: [ValidService.checkNumberInteger, ValidService.checkNumberFloatNotNegative],
  employee_ids: [ValidService.requiredChange],
  type: [ValidService.requiredChange],
};

model.dataFormDocGroup = {
  name: null,
  // company_id: null,
  user_ids: null, // optional - Danh sách người dùng
  // disabled: null, // required - Đã bị khóa chưa
},

model.validFormDocGroup = {
  name: [ValidService.required, ValidService.checkLength1(1,255), ValidService.checkSpaceString],
};

model.dataFormDocBusiness = {
  name: null, // required - Tên ngành kinh doanh
  code: null, // required, maxLength: 50 - Mã
  // company_id: null, // optional, ref: company - Mã công ty
  // disabled: null, // required - Đã bị khóa chưa
},

// validation các form khác
model.validFormDocBusiness = {
  name: [ValidService.required, ValidService.checkLength1(1,255), ValidService.checkSpaceString],
  code: [ValidService.required, ValidService.checkSpaceString, ValidService.checkSpaceStringCenter, ValidService.checkLength1(1,50)],
};

// dữ liệu mẫu các form khác
model.dataFormSearch = {
  keyName: undefined,
},


model.tableRules = {
  data: [],
  lengthMenu: [10, 20, 50, 100],
  allowPaging: true,
  allowSorting: true,
  allowSelect: true,
  showFormSearch: false,
  showUrl: true,
  total: 0,
  page: 1,
  limit: 10,
  offset: 0,
  sort: "order,-created_at",
  defaultSort: ["order", "ascending"],
  filters: "",
  recordSelected: [],
  dataSearch: {
    value: {
      start_time: "",
      end_time: "",
      type: "",
      status: ""
    },
    valid: {
      start_time: [],
      end_time: [],
      type: [],
      status: []
    },
    operator: {
      start_time: ":in_that_day:",
      end_time: ":in_that_day:",
      type: "",
      status: ""
    }
  }
};

export default model;
